import { render, staticRenderFns } from "./lightBoxNew.vue?vue&type=template&id=30ea0218&scoped=true&"
import script from "./lightBoxNew.vue?vue&type=script&lang=js&"
export * from "./lightBoxNew.vue?vue&type=script&lang=js&"
import style0 from "./lightBoxNew.vue?vue&type=style&index=0&id=30ea0218&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ea0218",
  null
  
)

export default component.exports